import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FORBIDDEN_ROUTE } from 'commons';
import { DtisAzureRoles } from '../..';
import { AzureAuthService } from '../azure-auth.service';

@Injectable({
  providedIn: 'root',
})
export class ReadUserGuard {
  router = inject(Router);
  azure = inject(AzureAuthService);
  /**
   *
   * @param route
   * @param state
   * @returns
   */
  canActivateChild(): boolean {
    if (this.azure.hasRole(DtisAzureRoles.USER_READ_ROLE)) {
      return true;
    }

    this.router.navigate([FORBIDDEN_ROUTE]);
    return false;
  }
}
